<template>
    <section class="acessorios-routine">
        <div class="acessorios-routine-content">
            <div class="header-wrapper">
                <!-- Breadcrumb -->

                <div class="turnback">
                    <!-- Back To -->
                    <back-to :urlreference="moduledefaultindex" />
                </div>

                <h1 class="heading-4">{{ headertitle }}</h1>
            </div>

            <!-- Content -->
            <div
                v-if="showformcreate || showformupdate"
                class="acessorios-form-wrapper"
            >
                <!-- Module Form -->
                <module-form
                    :csrftolken="csrftolken"
                    :routine="moduleroutine"
                    :moduleindex="moduleindex"
                    :routineurl="routineurl"
                    :moduledata="moduleData"
                    :customdata="customData"
                    :iconimgpath="iconimgpath"
                    :moduledefaultindex="moduledefaultindex"
                />
            </div>

            <div v-else class="">
                <span>Não existem dados para esta solicitação</span>
            </div>
        </div>
    </section>
</template>
<script>
import BackTo from "./../../elements/BackToElement.vue";
import ModuleForm from "./AccessorieForm.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";

export default {
    name: "AccessorieRoutine",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        moduleindex: {
            type: String,
            required: true,
        },
        moduleroutine: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        moduledata: {
            type: String,
            required: true,
        },
        moduledefaultindex: {
            type: String,
            required: false,
        },
        customdata: {
            type: String,
            required: false,
        },
        modulename: {
            type: String,
            required: true,
        },
        iconimgpath:{
            type: String,
            required: true,
        },
       
    },
    data: () => {
        return {
            showformcreate: true,
            showformupdate: true,
            moduleData: [],
            customData: [],
            urlback: "",
            headertitle: "",
        };
    },
    created() {
        //Set Module Data
        this.moduleData = JSON.parse(this.moduledata);
        this.customData = JSON.parse(this.customdata);

        //Set Conditional
        this.showformcreate =
            this.moduleData.length === 0 && this.moduleroutine === "POST"
                ? true
                : false;
        this.showformupdate =
            this.moduleData.length > 0 && this.moduleroutine === "PUT"
                ? true
                : false;

        //Set Header Title
        this.headertitle =
            this.moduleroutine === "POST"
                ? `Criar ${this.modulename}`
                : `Editar ${this.modulename}`;

        //Set Url Back
        //this.urlback = history.back();
    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        dynamicStyleModuleName(modulename) {
            return defaultWebsite.dynamicStyleModuleName(modulename);
        },
    },
    components: {
        backTo: BackTo,
        moduleForm: ModuleForm,
    },
};
</script>
